import axios from "axios";
import { langKey } from "@/i18n";
import qs from "qs";
const domainLocaleMap: Record<string, string> = Object.fromEntries(
  [
    // 英语域名
    ["en-v-ls.comfortweather.com", "en"],
    // 泰语域名
    ["th-v-ls.comfortweather.com", "th"],
    // 印尼语域名
    ["id-v-ls.comfortweather.com", "id"],
    // 美国
    ["en-mxwg.comfortweather.com", "en"],
    // 墨西哥
    ["es-mxwg.comfortweather.com", "es"],
    // 印地语域名
    ["hi-v-ls.comfortweather.com", "hi"],
    // 越南语域名
    ["vi-v-ls.comfortweather.com", "vi"],
    // 小米天气的小部件英文域名
    ["en-miwg.comfortweather.com", "en"],
    // 小米印地语域名
    ["hi-miwg.comfortweather.com", "hi"],
    // 小米印尼语域名
    ["id-miwg.comfortweather.com", "id"],
    // 巴西葡萄牙语
    ["pt-br-mils.comfortweather.com", "pt"],
    // 欧洲-葡萄牙语
    ["pt-mils.comfortweather.com", "pt-pt"],
    // 西班牙语
    ["es-mils.comfortweather.com", "es"],
    // 阿拉伯语
    ["arabic-mils.comfortweather.com", "ar"],
    // 土耳其语
    ["tr-mils.comfortweather.com", "tr-tr"],
    // 法语
    ["fr-mils.comfortweather.com", "fr-fr"],
    // 意大利语
    ["it-mils.comfortweather.com", "it-it"],
    // 乌尔都语
    ["urdu-mils.comfortweather.com", "ur"],
    // 越南语
    ["vi-mils.comfortweather.com", "vi"],
    // 泰语
    ["th-mils.comfortweather.com", "th"],
    // 英语
    ["en-mils.comfortweather.com", "en"],
    // 日语
    ["jp-mils.comfortweather.com", "ja-jp"],
    // 德语
    ["ger-mils.comfortweather.com", "de-de"],
    // 印尼语
    ["id-mils.comfortweather.com", "id"],
    // 波兰语
    ["po-mils.comfortweather.com", "pl-pl"],
    // 印尼语
    ["id-wi.comfortweather.com", "id"],
    // 西班牙语
    ["es-wi.comfortweather.com", "es"],
    // 英语域名
    ["en-wg.comfortweather.com", "en"],
    // 印地语域名
    ["hi-wg.comfortweather.com", "hi"],
    // 印尼语域名
    ["id-wg.comfortweather.com", "id"],
    // 西班牙语域名
    ["es-wg.comfortweather.com", "es"],
    // 孟加拉语
    ["bn-mils.comfortweather.com", "bn-bd"],
    // 希腊语
    ["el-mils.comfortweather.com", "el-gr"],
    // 希伯来语
    ["he-mils.comfortweather.com", "he"],
    // 韩语
    ["ko-mils.comfortweather.com", "ko"],
    // 乌克兰语
    ["uk-mils.comfortweather.com", "uk"],
    // 缅甸语
    ["my-mils.comfortweather.com", ""],
    // 俄语
    ["ru-mils.comfortweather.com", "ru-ru"],
    // 阿塞拜疆语
    ["az-mils.comfortweather.com", "az-latn-az"],
    // 匈牙利语
    ["hu-mils.comfortweather.com", "hu-hu"],
    // 罗马尼亚语
    ["ro-mils.comfortweather.com", "ro-ro"],
    // 塞尔维亚语
    ["sr-mils.comfortweather.com", "sr-rs"],
    // 保加利亚语
    ["bg-mils.comfortweather.com", "bg"],
    // 斯洛伐克语
    ["sk-mils.comfortweather.com", "sk"],
    // 繁体中文
    ["zh-hant-mils.comfortweather.com", "zh-hant"],
    // 僧伽罗语
    ["si-mils.comfortweather.com", "si"],
    // 捷克语
    ["cs-mils.comfortweather.com", "cs"],
  ].map(([key, value]) => [key, value])
);
export const urlLanguageParam = (() => {
  const { lan } = useLanguage();
  return (
    domainLocaleMap[window.location.hostname] ||
    (langKey.includes(lan) ? lan : domainLocaleMap[`${lan}.comfortweather.com`])
  );
})();
const axiosConfig = {
  baseURL: isDevEnv ? import.meta.env.VITE_API_PROXY : import.meta.env.VITE_API_ATRGET,
  timeout: 60 * 1000,
  headers: { "Content-Type": "application/json" },
};
const instance = axios.create(axiosConfig);
const appendUrlParams = (url: string, params: Record<string, string>) => {
  const queryString = qs.stringify(params, { encode: false });
  return `${url}?${queryString}`;
};
instance.interceptors.request.use(
  (config: any) => {
    const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localTimeZone = LocalStorage.getItem("time_zone") || defaultTimeZone;
    if (isBuildTest) {
      const url = window.location.href;
      const regex = /pm=(\d+)/g;
      const match = url.match(regex);
      const params = {
        Accept: localTimeZone,
        lan: urlLanguageParam,
      };
      config.url = match
        ? appendUrlParams(config.url, {
            ...params,
            ...match
              .join("&")
              .split("&")
              .reduce((acc, cur) => ({ ...acc, [cur.split("=")[0]]: cur.split("=")[1] }), {}),
          })
        : appendUrlParams(config.url, params);
    } else {
      config.url = appendUrlParams(config.url, {
        Accept: localTimeZone,
        lan: urlLanguageParam,
      });
    }
    return config;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  (response: any) => {
    // const resData = deepAddKey(response.data);
    const resData = response.data;
    if (!isDevEnv) {
      trackApiFetch(response.config.url);
    }
    return resData;
  },
  error => Promise.reject(error)
);

const trackApiFetch = (apiUrl: string) => {
  // @ts-ignore
  gtag("event", "fetchApi", { api: apiUrl });
};

export default instance;
